import React, {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useState,
} from 'react'

export enum Direction {
  LEFT = 'left',
  RIGHT = 'right',
}

export const NavigationContext = createContext<{
  setDirection: Dispatch<SetStateAction<Direction>>
  direction: Direction
}>({
  setDirection: () => null,
  direction: Direction.LEFT,
})

type PropTypes = {
  children: ReactNode
}

const NavigationProvider = (props: PropTypes) => {
  const { children } = props

  const [direction, setDirection] = useState<Direction>(Direction.LEFT)
  return (
    <NavigationContext.Provider
      value={{
        setDirection: setDirection,
        direction: direction,
      }}
    >
      {children}
    </NavigationContext.Provider>
  )
}

export default NavigationProvider
